<ng-template wmTemplate>
  @if (audioStreamingAvailable && !audioStreamingActive && !updatingAudioStreaming) {
    <fa-icon class="action" [icon]="faVolumeMute" (click)="setupAudioStreaming()"></fa-icon>
  }
  @if (audioStreamingAvailable && audioStreamingActive && !updatingAudioStreaming && !streamingPlayingAudio) {
    <fa-icon class="action" [icon]="faVolume" (click)="startPlayingAudio()"></fa-icon>
  }
  @if (audioStreamingAvailable && audioStreamingActive && !updatingAudioStreaming && streamingPlayingAudio) {
    <fa-icon class="action streaming-playing-audio" [icon]="faVolume" (click)="stopPlayingAudio()"></fa-icon>
  }
  @if (updatingAudioStreaming) {
    <fa-icon class="action" [icon]="faSyncAlt" animation="spin"></fa-icon>
  }
  @if (isHeadless && !offerReconnect && device && consoleSession) {
    <fa-icon class="action" [icon]="headlessMuted ? faVolumeMute : faVolume"
             [title]="headlessMuted ? 'Unmute audio' : 'Mute audio'"
             (click)="toggleHeadlessMute()"></fa-icon>
  }
</ng-template>

@if (audioStreamingAvailable) {
  <audio #audio id="audio" class="audio-placeholder"></audio>
}

@if (!offerReconnect && device && consoleSession) {
  @if (consoleState === CONNECTED) {
    <wm-workbench-console-toolbar [device]="device" [viewId]="config.id"></wm-workbench-console-toolbar>
  }
  <div #consoleContainer class="console-container">
    @if (isHeadless) {
      <wm-headless-console [deviceId]="deviceId" [consoleSession]="consoleSession" [projectId]="projectId" [stateEvents]="stateEvents" [viewConfig]="config" [muted]="headlessMuted" class="console"></wm-headless-console>
    }
    @if (devicePlatformFamily === 'mobile') {
      <wm-mobile-console [consoleSession]="consoleSession" [projectId]="projectId" [deviceProperties]="device.properties" [stateEvents]="stateEvents" [viewConfig]="config" [isActiveView]="isActiveView" class="console"></wm-mobile-console>
    }
    @if (devicePlatformFamily === 'desktop' && consoleSession?.providerType === 'VCloudTestCenter') {
      <wm-desktop-vmware-console [projectId]="projectId" [consoleSession]="consoleSession" [stateEvents]="stateEvents" [viewConfig]="config" class="console"></wm-desktop-vmware-console>
    }
    @if (devicePlatformFamily === 'desktop' && consoleSession?.providerType === 'macvirt') {
      <wm-desktop-macvirt-console [projectId]="projectId" [consoleSession]="consoleSession" [stateEvents]="stateEvents" [viewConfig]="config" class="console"></wm-desktop-macvirt-console>
    }
    @if (devicePlatformFamily === 'desktop' && consoleSession?.providerType === 'proxmox') {
      <wm-desktop-proxmox-console [projectId]="projectId" [consoleSession]="consoleSession" [stateEvents]="stateEvents" [viewConfig]="config" class="console"></wm-desktop-proxmox-console>
    }
    @if (showVisionSimOverlay) {
      <wm-impaired-vision-simulation-overlay-view
        [deviceConsoleViewId]="this.config.id"
        [simulations]="visionSimulations">
      </wm-impaired-vision-simulation-overlay-view>
    }
  </div>

} @else {
  @if (offerReconnect && singleUserConsoleFeatureActive && accessedByOtherUser) {
    <div class="disconnected">
      <div class="spinner-centered">
        <p class="spinnerlabel">Device currently accessed by {{ otherUserInfo?.name }}</p>
      </div>
    </div>
  } @else if (offerReconnect) {
    <button pButton type="button" (click)="reconnect()" icon="true" label="Reconnect">
      <fa-icon [icon]="faPlug"></fa-icon>
    </button>
  } @else {
    <div class="disconnected">
      <div class="spinner-centered">
        <p-progressSpinner [strokeWidth]="'3px'"></p-progressSpinner>
        @if (!device) {
          <div class="spinnerlabel">Connecting...</div>
        } @else if (!deviceRunning) {
          <div class="spinnerlabel">Deploying Device...</div>
        } @else if (!deviceSetupDone) {
          <div class="spinnerlabel">Configuring Device...</div>
        } @else if (!consoleSession) {
          <div class="spinnerlabel">Launching Console...</div>
        }
      </div>
    </div>
  }
}
